<script setup lang="ts">
import { computed } from 'vue'
import { Play, Plus } from 'lucide-vue-next'
import SectionHead from './SectionHead.vue'
import type { TrainingAsset } from '../../../types/supplier'

const props = defineProps<{ assets: TrainingAsset[]; canEdit: boolean; showAll?: boolean }>()
defineEmits<{ seeAll: [] }>()

const rows = computed(() => props.showAll ? props.assets : props.assets.slice(0, 5))
const meta = (a: TrainingAsset) => {
  const names = a.relatedProducts.map(p => p.name).join(', ')
  return names ? `${a.assetType || 'Video'} · For ${names}` : (a.assetType || 'Video')
}
</script>

<template>
  <section aria-labelledby="csp-training">
    <SectionHead id="csp-training" title="Training & enablement" :count="assets.length">
      <router-link v-if="canEdit" :to="{ name: 'supplier-training-create' }" class="csp-link inline-flex items-center gap-1">
        <Plus :size="13" aria-hidden="true" /> Add video
      </router-link>
    </SectionHead>

    <ul>
      <li v-for="a in rows" :key="a.id" class="csp-row csp-row-link relative flex items-center gap-3 border-b border-(--csp-divider) last:border-b-0">
        <span class="w-8 h-8 rounded-[6px] bg-(--csp-tag) flex items-center justify-center shrink-0 text-(--csp-text-2)" aria-hidden="true">
          <Play :size="14" />
        </span>
        <div class="min-w-0 flex-1">
          <a :href="a.url" target="_blank" rel="noopener" class="csp-title-link font-semibold after:absolute after:inset-0 after:content-['']">{{ a.title }}</a>
          <p class="text-[13px] csp-muted truncate" :title="meta(a)">{{ meta(a) }}</p>
        </div>
        <a :href="a.url" target="_blank" rel="noopener" class="csp-link text-[13px] shrink-0 relative z-10" :aria-label="`Open ${a.title}`">Open</a>
      </li>
      <li v-if="!assets.length" class="csp-row flex items-center text-sm csp-muted">No training videos yet.</li>
    </ul>

    <button v-if="!showAll && assets.length > 5" type="button" class="csp-link text-[13px] mt-3" @click="$emit('seeAll')">
      See all {{ assets.length }} videos
    </button>
  </section>
</template>
